import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { SelectItem } from 'primeng/api';
import { ExerciseModel } from 'projects/core/src/lib/models/exercise.model';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-element-new',
  templateUrl: './element-new.component.html',
  styleUrls: ['./element-new.component.scss']
})
export class ElementNewComponent implements OnInit {

  @Input() exercise: ExerciseModel = null;

  public loading = false;
  public submitting = false;
  public messages: Array<any> = [];
  public types: Array<SelectItem>;
  public inheritVisible = false;
  public form: UntypedFormGroup = this.fb.group({
    name: new UntypedFormControl('', [Validators.required]),
    title: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('', [Validators.required])
  });

  constructor(
    private api: ApiService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    if (this.auth.checkRightOrRedirect('admin.element.create')) {
      this.types = [
        {
          value: null,
          label: this.transloco.translate('common.labels.please_choose')
        },
        {
          value: 'html',
          label: this.transloco.translate('common.labels.html-file')
        },
      ];
    }
  }

  onCancel(): void {
    if (this.exercise !== null) {
      this.router.navigate(['/exercises', this.exercise.id]);
    }
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      if (this.exercise?.shouldShowInheritDialog()) {
        this.inheritVisible = true;
      } else {
        this.saveElement(false);
      }
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  public saveElement(inherit: boolean = false): void {
    const payload: any = this.form.value;
    payload.exercise_id = this.exercise.id;
    payload.inherit = inherit;
    this.submitting = true;
    this.api.saveModel('elements', null, payload).subscribe({
      next: (result: any) => {
        this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: payload.name }), this.transloco.translate('common.saved'));
        this.router.navigate(['/exercises', this.exercise.id, 'elements', result.data.id]);
      },
      error: (error: any) => {
        this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
        FormHelper.setBackendErrors(this.form, error.fielderrors);
      }
    }).add(() => {
      this.submitting = false;
    });
  }

}
